import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const getSettings = api(async function getSettings() {
    return query(
        gql`
            query Settings {
                getSettings
            }
        `,
        {},
        { returns: "getSettings" }
    )
})
